<template>
<ul>
    <template v-for="item in enlists">
        <li v-if="item.is_submit" :key="item.id">
            <span></span>
            <router-link class="submitForm" :to="`single-family-game/perview/${item.id}`">{{item.label}}</router-link>
        </li>
        <li v-else :key="item.id">
            <span>{{item.label}}</span>
            <router-link class="btn btn-primary" :to="`single-family-game/edit/${item.id}`">{{$lang('修改')}}</router-link>
            <b-btn  variant="danger" @click="$emit('onSumbit',item.id)">{{$lang('提交')}}</b-btn>
            <b-btn variant="info" @click="$emit('onCancle',item.id)">{{$lang('BTN_NO')}}</b-btn>
        </li>
    </template>
</ul>
</template>

<script>
export default {
    props: {
        enlists: {
            type: Array,
            default () {
                return [{
                    id: "",
                    perview_uri: '',
                    editor_uri: '',
                    label: "",
                    is_submit: false,
                }]
            }
        }
    }
}
</script>
